import { SVGProps } from 'react'

const ArrowDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.2373 1.54688L5.7373 6.04687L10.2373 1.54687"
        stroke={props?.color || '#19191A'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArrowDown
